//App.js
import React from 'react'
import i18n from './lang'
import { Route,Switch,Redirect} from 'react-router-dom'
import Routers from './routes/router'
import NotFound from './pages/NotFound'
import * as streamingjs from 'fubonstreamingjs';
import QuoteBox from './components/Streaming/QuoteBox'
import { observer } from "mobx-react";
import DataStore from "./components/Streaming/DataStore"
import AlertsStore from "./mobx/AlertsStore"
import { Spin } from 'antd';
import APPstyles from '@/App.less';
import common from '@/asserts/js/common';
import WDSInstance from '@/asserts/js/wds/index';

// --- Matomo 集成步骤 1: 引入 Hook ---
// 请确保 useMatomo.js 文件在 src/hooks/ 目录下
import useMatomo from './hooks/useMatomo';

const store=new DataStore()
const alertsStore=new AlertsStore()

// --- Matomo 集成步骤 2: 创建一个函数组件包装器 ---
// 因为 App 是 Class Component，不能直接用 Hook，所以需要这个中间件
const MatomoTracker = () => {
  useMatomo(); // 调用监听路由的 Hook
  return null; // 这个组件不渲染任何 UI
};

class App extends React.Component {
  subscribeRicListIsUpdated = true
  constructor(props) {
    super(props)
    this.state = {
      uid:'',
      bodyH:Number(document.body.clientHeight),
      bodyW: Number(document.body.clientWidth),
      minbodyW:1280,
      mobilebodyW:768,
      isLoading: true,
      isUnderMaintenance: true,
    }
    this.isRequest=false;
  }
  //初始化
  onloadDataFun(){
    // 语言
    let lang=localStorage.getItem('lang')
    i18n.changeLanguage(lang?lang:'zh-CN')
    localStorage.setItem('lang',lang?lang:'zh-CN')
    // 获取uid
    let uid=sessionStorage.getItem('uid')
    this.setState({
      uid:uid
    })
  }
  // 获取路由跳转
  callbackPathnameApp(data){
    this.props.history.push(data)
  }
  // 获取uid--login页面
  callbackUid(data){
    this.setState({
      uid:data
    })
  }
  //登录跳转到quote页面--login页面
  callbackpathname(data){
    this.props.history.push(data)
  }
  //监听窗口大小改变
  resizeBodyFun(){ 
    this.setState({
      bodyW:Number(document.body.clientWidth),
      bodyH:Number(document.body.clientHeight) 
    })
  }
  //更改本地存储数据的长度
  chgLocalStorageFun(){
    let wlData=localStorage.getItem('watchlistDataAll')
    let slData=localStorage.getItem('symbolDataAll')
    let tabData=localStorage.getItem('tabDataAll')
    // watchlistDataAll
    if(wlData){
      wlData=JSON.parse(wlData)
      this.dealwatchlistDataFun('watchlistDataAll',wlData)
    }
    // symbolDataAll
    if(slData){
      slData=JSON.parse(slData)
      this.dealwatchlistDataFun('symbolDataAll',slData)
    }
    // tabDataAll
    if(tabData){
      tabData=JSON.parse(tabData)
      this.dealLocalStorageTabFun('tabDataAll',tabData)
    }
  }
  // watchlistData
  dealwatchlistDataFun(name,data){
    // 只有在 data 是一个有效数组时才执行处理
    if (data && Array.isArray(data)) {
      // 遍历数组中的每一个元素
      data.forEach(element => {
        // 由于数据结构可能是二维的（例如：[ [], [{...}], [] ]），
        // 我们需要检查元素本身是否也是一个数组，并相应地处理。
        const itemsToProcess = Array.isArray(element) ? element : [element];

        // 遍历需要处理的对象
        itemsToProcess.forEach(item => {
          // 严谨性检查：
          // 1. 确保 item 不是 null 或 undefined
          // 2. 确保 item 是一个对象
          // 3. 确保 item 拥有 'ric' 属性
          // 4. 确保 item.ric 不是空字符串 ''
          if (item && typeof item === 'object' && item.hasOwnProperty('ric') && typeof item.ric === 'string' && item.ric) {
            // 将 ric 后缀转换为大写进行比较，实现不区分大小写的匹配
            if (item.ric.toUpperCase().endsWith('.NB')) {
              // 替换后缀：截取 '.NB' 前面的部分，然后拼接上 '.NQT'
              item.ric = item.ric.slice(0, -3) + '.NQT';
            }
          }
        });
      });
    }
    let newData=[[],[],[],[],[],[],[],[]]
    if(data.length==6){
      for(let i in data){
        newData[Number(i)+2]=data[i]
      }
      localStorage.setItem(name,JSON.stringify(newData))
    }else{
      localStorage.setItem(name,JSON.stringify(data));
    }
  }
  // tabData
  dealLocalStorageTabFun(name,data){
    if(data.length==6){
      let obj2={
        name:'Screener',
        disabled:'',
        index:2
      }
      let obj3={
        name:'Sector1',
        disabled:'',
        index:3
      }
      data.splice(2, 0, obj2)
      data.splice(3, 0, obj3)
      localStorage.setItem(name,JSON.stringify(data))
      return
    }
    if(data[3]['name']!=='Sector1'){
      data[3]['name']='Sector1'
      localStorage.setItem(name,JSON.stringify(data))
    }
  }
  handleResize(){
    this.resizeBodyFun()
  }
  handleBack(){
    window.history.pushState(null, null, document.URL)
  }
  //监听浏览器回退事件
  popstateFun(){
    if (window.history && window.history.pushState) {
      window.addEventListener('popstate', this.handleBack, false)
    }
  }

  onCommonData(){
    this.setState({
      isLoading:false,
      isUnderMaintenance: false,
    });
  }

  // 有两个要注意的：
  // 1. 这个功能只适用于PC.
  // 2. 即使调用Market data api的这个网站维护的API失败了，那也应该让用户进去，而不是让它loading，这种情况下就当网站没在维护中
  // 检查维护状态的 API 请求
  checkMaintenanceStatus = async () => {
    try {
      const response = await fetch(common.getHttp + 'website-maintenance-config');
      const data = await response.json();

      // 如果没在维护中，那就返回了404
      if (Number(data['status']) === 404) {
        this.onCommonData();
      } else {
        // 维护状态下当前页显示维护页的URL
        const maintenanceUrl = data['url']; // https://dcatest.fbs.com.tw/RspWebSite/
        if (maintenanceUrl) {
          window.location.href = maintenanceUrl; 
        } else {
          this.onCommonData();
          console.error('Maintenance URL is not provided in the API response.');
        }
      }
    } catch (error) {
      this.onCommonData();
      console.error('Error fetching maintenance status:', error);
    }
  }

  componentDidMount(){
    const {bodyW, minbodyW} = this.state;

    if(process.env.REACT_APP_ENV_NAME === 'DEV'){
      this.onCommonData();
    }else{
      if(bodyW > minbodyW){
        this.checkMaintenanceStatus();
      }else{
        this.onCommonData();
      }
    }
     
    this.onloadDataFun();
    this.popstateFun();
    this.chgLocalStorageFun();
    // 判断是否有断开，如果有则然后重连
    WDSInstance.tick();

    window.addEventListener('resize', this.handleResize.bind(this));
    document.addEventListener('wds:message', this.handleWdsSocketMessage);

  }
  componentWillUnmount() {    
    window.removeEventListener('resize', this.handleResize.bind(this));
    window.removeEventListener('popstate', this.handleBack, false);
    document.removeEventListener('wds:message', this.handleSocketMessage,false);
    WDSInstance.clearTick();
  }
   arraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    arr1.sort();
    arr2.sort();
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
  componentDidUpdate(){
    //本次与上次不相同的才订阅
    if(!this.arraysEqual(JSON.parse(JSON.stringify(WDSInstance.ricList)),JSON.parse(JSON.stringify(store.subscribeRicList)))){
      WDSInstance.unsubscribe(WDSInstance.ricList);
      WDSInstance.subscribe(store.subscribeRicList);
    }
    store.setSubscribeRicListIsUpdated(false);
    console.log(JSON.stringify(store.subscribeRicList),'componentDidUpdate');
  }
  handleWdsSocketMessage=(event)=>{
   // console.log('Received wds message:', event.detail);
    store.setStreamingData(event.detail.formatData)
  }
  render() {
    const {uid,bodyW,minbodyW,mobilebodyW,bodyH, isLoading, isUnderMaintenance}=this.state

    // 如果在维护状态下，则不需要渲染其他组件
    if (isUnderMaintenance) {
      return (
        <div className={APPstyles.flex_center}><Spin spinning={isLoading} /></div>
      );
    }
    const quoteboxes = store.subscribeRicList.map((ric, seq) => {
      return (
        <QuoteBox 
          key={seq}
          ric={ric} 
          seq={seq}
        />
      )
    })

    // 动态更换地址栏链接
    let locationName=window['location']['pathname'].split('/')
    return (
      <div style={{height:'100%'}}>
        {/* 
          [Matomo集成] 3. 使用 Tracker 
          因为它在 index.js 的 <BrowserRouter> 内部，所以这里可以正常工作。
        */}
        <MatomoTracker />
        <Switch>
          {Routers.map((item, index) => {
            return <Route key={index} path={item.path} exact render={props =>
                    !item.auth? 
                      <item.component 
                        {...props}
                        locationName={locationName}
                        bodyH={bodyH}
                        bodyW={bodyW}
                        minbodyW={minbodyW}
                        mobilebodyW={mobilebodyW}
                        isPC={bodyW>minbodyW}
                        isTablet={bodyW<=minbodyW}
                        isMobile={bodyW<=mobilebodyW}
                        callbackUid={this.callbackUid.bind(this)} 
                        callbackpathname={this.callbackpathname.bind(this)} 
                      />
                    : sessionStorage.getItem('uid')||uid? 
                        <item.component 
                          {...props} 
                          store={store}
                          alertsStore={alertsStore}
                          bodyH={bodyH}
                          bodyW={bodyW}
                          minbodyW={minbodyW}
                          mobilebodyW={mobilebodyW}
                          isPC={bodyW>minbodyW}
                          isTablet={bodyW<=minbodyW}
                          isMobile={bodyW<=mobilebodyW}
                          locationName={locationName}
                          callbackPathnameApp={this.callbackPathnameApp.bind(this)} 
                        /> 
                      : 
                        <Redirect 
                          to={{
                            pathname:('/'+locationName[1]+'/login'),
                            state: { from: props.location }
                          }} 
                        />
                    } 
                  />
            })}
            <Route render={()=>404}/>
          </Switch>
          <div className="workspacebox" hidden>
          <div id="demo1">
            <div>{quoteboxes}</div>
          </div>
        </div>
      </div>
    )
  }
}
export default observer(App);